export var CompactionStrategy;
(function (CompactionStrategy) {
    CompactionStrategy["COMPACTION_STRATEGY_BINPACK"] = "BINPACK";
    CompactionStrategy["COMPACTION_STRATEGY_SORT"] = "SORT";
    CompactionStrategy["COMPACTION_STRATEGY_ZORDER"] = "ZORDER";
})(CompactionStrategy || (CompactionStrategy = {}));
